import React, { useEffect, useRef, useState } from "react";
import { Settings } from "lucide-react";
import { listWorkspacesAll } from "../api/boardApi";

// Small dropdown shown above the boards grid. Click → switch the current
// workspace; admins also see "Manage workspaces" → /workspaces.
//
// The selected workspace id is persisted in localStorage so reopens land
// where the user left off.
const STORAGE_KEY = "smarthatch:boards:workspace";

export default function WorkspaceSwitcher({ value, onChange, onManageClick }) {
  const [open, setOpen] = useState(false);
  const [workspaces, setWorkspaces] = useState([]);
  const ref = useRef(null);

  useEffect(() => {
    listWorkspacesAll()
      .then((res) => {
        setWorkspaces(res.data || []);
        if (!value) {
          const stored = localStorage.getItem(STORAGE_KEY);
          const fromStorage = stored && res.data?.find((w) => w._id === stored);
          const def = fromStorage || res.data?.find((w) => w.default) || res.data?.[0];
          if (def) onChange(def);
        }
      })
      .catch(() => { /* silent */ });
  }, []); // eslint-disable-line react-hooks/exhaustive-deps

  useEffect(() => {
    const onDoc = (e) => { if (!ref.current?.contains(e.target)) setOpen(false); };
    document.addEventListener("mousedown", onDoc);
    return () => document.removeEventListener("mousedown", onDoc);
  }, []);

  const pick = (w) => {
    setOpen(false);
    localStorage.setItem(STORAGE_KEY, w._id);
    onChange(w);
  };

  return (
    <div className="ws-switcher" ref={ref}>
      <button type="button" className="ws-switcher-btn" onClick={() => setOpen((o) => !o)}>
        <span className="ws-dot" style={{ background: value?.color || "#ef3a3a" }}>{value?.icon || "▥"}</span>
        <span className="ws-name">{value?.name || "Loading…"}</span>
        <span className="ws-chev">▾</span>
      </button>
      {open && (
        <div className="ws-menu">
          {workspaces.map((w) => (
            <button
              key={w._id}
              type="button"
              className={`ws-menu-item ${w._id === value?._id ? "active" : ""}`}
              onClick={() => pick(w)}
            >
              <span className="ws-dot" style={{ background: w.color || "#ef3a3a" }}>{w.icon || "▥"}</span>
              <span className="ws-name">{w.name}</span>
              {w.default && <span className="ws-default">default</span>}
            </button>
          ))}
          {onManageClick && (
            <>
              <div className="ws-menu-divider" />
              <button type="button" className="ws-menu-item ws-manage" onClick={() => { setOpen(false); onManageClick(); }}>
                <Settings size={14} className="me-1" /> Manage workspaces
              </button>
            </>
          )}
        </div>
      )}
    </div>
  );
}
